import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Icon } from '@holmescorp/base-widgets/icon';
import { createNlsMiddleware, tgfcomplete, userstate } from '@holmescorp/lcc-state';
import { numeral } from '@holmescorp/numeral';
import css from '../css/topicaccordion.m.css';
const nls = createNlsMiddleware('settings');
const factory = create({ theme, userstate, nls }).properties();
export const TopicTitle = factory(({ properties, middleware: { theme, userstate, nls } }) => {
    const themeCss = theme.classes(css);
    const { get, path } = userstate;
    const status = get(path('status'));
    const { key, title, useTitle, readtime, useQuizScore = false } = properties();
    let readtimeFmt;
    const { messages: { is_demo = false, demo_allowed_topics = '[]' } } = nls();
    let allowed_topics = [];
    try {
        allowed_topics = JSON.parse(demo_allowed_topics);
    }
    catch (e) {
        console.warn(`json parse error ${e}`, demo_allowed_topics);
    }
    const isLocked = is_demo === 'true' && allowed_topics.indexOf(`${key}`) === -1;
    const lockIcon = isLocked ? v('span', { classes: [themeCss.lockIcon] }, [w(Icon, { faname: 'lock' })]) : null;
    let score = 0;
    if (status === undefined) {
        readtimeFmt = numeral(readtime !== undefined ? readtime : 0).format('0');
    }
    else {
        const { readtime: rt, percent } = status[key].data;
        readtimeFmt = numeral(rt).format('0');
        score = percent;
    }
    const completed = tgfcomplete.has(key) && useTitle ? themeCss.completed : null;
    return v('div', { classes: [themeCss.setTitleBlock] }, [
        v('div', { classes: [themeCss.statusLine] }),
        w('TopicStatusIcon', { key, useQuizScore: false }),
        useTitle
            ? v('span', { key: `${key}-title`, classes: [themeCss.setTitle, completed] }, [lockIcon, title])
            : null,
        v('span', { key: `${key}-reading`, classes: [themeCss.setProgress] }, [
            `${readtimeFmt} min`,
            useQuizScore && score > 0
                ? v('div', { classes: [themeCss.scorePill] }, [
                    v('span', { classes: [themeCss.scoreLabel] }, [`${numeral(score).format('0%')}`])
                ])
                : null
        ])
    ]);
});
